"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceCompanyConduct = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdultServiceCompanyConduct = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.adult_service_company_conduct.label',
    fallbackLabel: 'How does your company conduct ongoing oversight and systematic verification to ensure that merchants maintain appropriate licensing and comply with both internal standards and external legal requirements (such as restrictions on offering services in jurisdictions where they are prohibited or restricted)? What measures are employed to enforce these restrictions, and what actions are taken if a merchant fails to meet these compliance obligations?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
